import { DOWNLOAD_LINK_CLICK, DownloadLinkType } from '../constants/attributesAnalytics';

const BOM = '\uFEFF';

type ContentType = 'text/csv;charset=utf-8;' | 'application/zip';

export const downloadData = (
  blob: BlobPart,
  name: string,
  { contentType, bom }: { contentType?: ContentType; bom?: boolean } = {},
  isScorm = false,
) => {
  const blobData = contentType === 'application/zip' ? blob : `${bom ? BOM : ''}${blob}`;
  const url = window.URL.createObjectURL(new Blob([blobData], { type: contentType ?? 'text/csv;charset=utf-8;' }));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', name);
  if (isScorm) {
    link.setAttribute(DOWNLOAD_LINK_CLICK.TYPE, DownloadLinkType.Scorm);
  }
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
